module.exports = __webpack_public_path__ + "img/thueringen.3c64c71.webp";